function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: "14,20 14,12 21,16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M27.49,21.934c-0.231,1.255-1.242,2.216-2.505,2.399C22.98,24.624,19.678,25,16,25c-3.679,0-6.982-0.376-8.986-0.667c-1.262-0.183-2.273-1.144-2.505-2.398C4.256,20.562,4,18.545,4,16c0-2.546,0.256-4.564,0.509-5.937c0.231-1.254,1.241-2.214,2.503-2.398C9.009,7.374,12.3,7,16,7c3.699,0,6.989,0.374,8.986,0.665c1.262,0.184,2.272,1.145,2.503,2.399C27.743,11.439,28,13.461,28,16C28,18.538,27.743,20.559,27.49,21.934z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.35b92066404ef6f7442e0417135fef04.svg";
export { ForwardRef as ReactComponent };